export default __webpack_public_path__ + "fonts/tpl_6.724f95905d520271f4c83eb130a9a9c4.png";